export const mockCompanyProfile = {
  user_id: 12,
  email: "",
  country_id: 19,
  city_id: 20,
  registration_date: "",
  name_en: "",
  name_trans: { ar: "" },
  description_en: "",
  description_trans: { ar: "" },
  url: "",
  post_office: "",
  address_en: "",
  address_trans: { ar: "" },
  phone_number: "",
  employee_phone_number: "",
  nationality_id: 19,
  commercial_register: "",
  employees_num: 0,
  expected_employees_num: "",
  logo: "",
  company_type: "",
  contacted: false,
  client: "",
  satisfied: false,
  culture: "",
  financial_ability: "",
  service_required: "",
  our_contact: "",
  hr_dept: false,
  trusted: false,
  apply_on_other_site: false,
  apply_url: "",
  pdf_mode: false,
  optional_end_date: false,
  categories: [],
  countryCode: "",
  title_id: "",
  full_name: "",
  position: "",
  mobile: "",
  employee_email: "",
};

export const clientOptions = [
  { value: "NO", label: "No", arabic_label: "لا" },
  { value: "YES", label: "Yes", arabic_label: "نعم" },
  { value: "FREE", label: "Free", arabic_label: "مجاني" },
  { value: "UNDEFINED", label: "Undefined", arabic_label: "غير محدد" },
];

export const cultureOptions = [
  { value: "PROFESSIONAL", label: "Professional", arabic_label: "محترف" },
  {
    value: "NOT_PROFESSIONAL",
    label: "Not Professional",
    arabic_label: "غير محترف",
  },
  { value: "MEDIUM", label: "Medium", arabic_label: "متوسط" },
];

export const serviceOptions = [
  { value: "ONLINE", label: "Online", arabic_label: "عبر الإنترنت" },
  { value: "EMPLOYMENT", label: "Employment", arabic_label: "توظيف" },
  {
    value: "HR_ASSISTANCE",
    label: "HR Assistance",
    arabic_label: "مساعدة الموارد البشرية",
  },
];

export const ourContactOptions = [
  { value: "NO", label: "No", arabic_label: "لا" },
  { value: "HR", label: "HR", arabic_label: "الموارد البشرية" },
];

export const companyTypeOptions = [
  { value: "A", label: "A", arabic_label: "A" },
  { value: "B", label: "B", arabic_label: "B" },
  { value: "C", label: "C", arabic_label: "C" },
  { value: "D", label: "D", arabic_label: "D" },
];

export const financialAbilityOptions = [
  { value: "POOR", label: "Poor", arabic_label: "فقير" },
  { value: "GOOD", label: "Good", arabic_label: "جيد" },
];
